export default function BenefitsSection() {
  const solutions = [
    {
      title: "Déshumidificateurs pour Serres Maraîchères",
      description: "Solutions adaptées aux cultures de tomates, concombres, poivrons et autres légumes. Contrôle précis de l'hygrométrie pour prévenir les maladies fongiques et optimiser la croissance.",
      image: "https://public.readdy.ai/ai/img_res/8a2f829e18e9622d5a173f1b19554890.jpg",
      features: [
        "Prévention botrytis et mildiou",
        "Optimisation de la croissance",
        "Réduction traitements phytosanitaires",
        "Amélioration qualité des fruits"
      ]
    },
    {
      title: "Déshumidificateurs pour Serres Horticoles",
      description: "Systèmes spécialement conçus pour les cultures florales et plantes ornementales. Maintien d'une hygrométrie stable pour des floraisons optimales et une qualité visuelle irréprochable.",
      image: "https://readdy.ai/api/search-image?query=Modern%20flower%20greenhouse%20with%20colorful%20blooming%20plants%2C%20professional%20dehumidification%20system%2C%20ornamental%20plant%20cultivation%2C%20climate%20controlled%20environment%2C%20vibrant%20flowers%2C%20professional%20agricultural%20photography&width=600&height=400&seq=airpure-serre-horticole&orientation=landscape",
      features: [
        "Protection des floraisons",
        "Qualité visuelle optimale",
        "Durée de conservation prolongée",
        "Réduction de l'oïdium"
      ]
    },
    {
      title: "Déshumidificateurs Industriels",
      description: "Solutions haute capacité pour grandes serres et espaces industriels. Équipements robustes capables de traiter de grands volumes avec une efficacité énergétique maximale.",
      image: "https://readdy.ai/api/search-image?query=Large%20industrial%20greenhouse%20with%20advanced%20dehumidification%20equipment%2C%20extensive%20plant%20cultivation%2C%20professional%20climate%20control%20system%2C%20commercial%20agricultural%20facility%2C%20modern%20technology&width=600&height=400&seq=airpure-industriel&orientation=landscape",
      features: [
        "Haute capacité de traitement",
        "Efficacité énergétique maximale",
        "Pilotage centralisé",
        "Maintenance simplifiée"
      ]
    }
  ];

  return (
    <section id="solutions" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Nos Solutions de Déshumidification</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Des équipements adaptés à chaque type de culture et dimension de serre
          </p>
        </div>

        <div className="space-y-12">
          {solutions.map((solution, index) => (
            <div 
              key={index} 
              className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-8 items-center bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300`}
            >
              <div className="lg:w-1/2">
                <img 
                  src={solution.image}
                  alt={solution.title}
                  className="w-full h-80 object-cover object-top"
                />
              </div>
              <div className="lg:w-1/2 p-8">
                <h3 className="text-3xl font-bold text-gray-900 mb-4">{solution.title}</h3>
                <p className="text-gray-600 mb-6 leading-relaxed text-lg">{solution.description}</p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {solution.features.map((feature, idx) => (
                    <div key={idx} className="flex items-center">
                      <div className="w-2 h-2 bg-[#4F8B3A] rounded-full mr-3"></div>
                      <span className="text-gray-700">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
